import { render, staticRenderFns } from "./ARichTextEditor.vue?vue&type=template&id=1a7e1b04&scoped=true&"
import script from "./ARichTextEditor.vue?vue&type=script&lang=js&"
export * from "./ARichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./ARichTextEditor.vue?vue&type=style&index=0&id=1a7e1b04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e1b04",
  null
  
)

export default component.exports